import type { AdvisorCoaches, ResponseBaseListAdvisorCoachesResponse } from "@profile-service-types/index.ts";
import type { UseQueryOptions } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";
import type { Ref } from "vue";
import { computed } from "vue";
import { profileServiceRequest } from "@/services/utils";

interface Args<TData = AdvisorCoaches> {
  q: Ref<string>;
  useQueryOptions?: Partial<UseQueryOptions<AdvisorCoaches[], Error, TData>>;
}

export const getQueryKey = (q: Ref<string>) => ["fetchGetAdvisorCoaches", q];

export const useGetAdvisorCoaches = <TData = AdvisorCoaches[]>({ q, useQueryOptions }: Args<TData>) => {
  const fetchGetAdvisorCoaches = (): Promise<ResponseBaseListAdvisorCoachesResponse["data"]["items"]> =>
    profileServiceRequest({
      method: "get",
      url: "/advisors/coaches/",
      params: { q: q.value },
    }).then((val: { data: ResponseBaseListAdvisorCoachesResponse }) => {
      const listData = val?.data?.data;
      const items = listData?.items;
      return items;
    });
  return useQuery<AdvisorCoaches[], Error, TData>({
    queryKey: computed(() => getQueryKey(q)),
    queryFn: fetchGetAdvisorCoaches,
    ...useQueryOptions,
  });
};
